import { render, staticRenderFns } from "./courseCatalogue.vue?vue&type=template&id=4a6951fa&scoped=true&"
import script from "./courseCatalogue.vue?vue&type=script&lang=js&"
export * from "./courseCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./courseCatalogue.vue?vue&type=style&index=0&id=4a6951fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6951fa",
  null
  
)

export default component.exports